export const isMobile = () =>
  // return /(Mobi|Android|iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  'ontouchstart' in document.documentElement;

export const isAndroid = () => /Android/i.test(navigator.userAgent);

export const isChrome = () => /Android/i.test(navigator.userAgent);
